import { useQuery } from '@tanstack/react-query';

import { getFilters } from '@/features/filters/api';
import { filterKeys } from '@/features/filters/keys';

export const useFilters = () => {
  return useQuery({
    queryKey: filterKeys.filters,
    queryFn: getFilters,
    staleTime: Infinity,
  });
};
